import { c as _c } from "react/compiler-runtime";
import { CRM_PIPELINE_API } from 'modules/crm/api/crm-pipeline-api';
import { PipelineInterface } from 'modules/crm/types/pipeline-interface';
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { DataWithPaginationInterface } from 'shared/types/pagination-interface';
export function usePipelineList(shouldFetch) {
  const $ = _c(6);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== shouldFetch || $[2] !== user) {
    t1 = () => {
      if (user && shouldFetch) {
        return `${CRM_PIPELINE_API}/list-all`;
      }
    };
    $[1] = shouldFetch;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: pipelineStage
  } = useControlledSwr(t1, fetcher, undefined, shouldFetch);
  let t2;
  if ($[4] !== pipelineStage) {
    t2 = {
      pipelineStage
    };
    $[4] = pipelineStage;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}